import * as React from 'react';
import Section from '../../Section';
import EstimatedScore from './EstimatedScore';
import Scores from './Scores';
import Comparisons from './Comparisons';
import './ResultsContent.css';
import { ScoreNumbers } from './ResultsContainer';

interface Props {
    company: ScoreNumbers;
    industryMedian: ScoreNumbers;
    industryNPS: ScoreNumbers;
    stage: string;
    type: string;
    yourScore: number;
    industryScore: number;
    digitalNativeScore: number;
}

class ResultsContent extends React.Component<Props> {
    render() {
        const {
            company, industryMedian, industryNPS, stage, type, yourScore, industryScore, digitalNativeScore
        } = this.props;

        return (
            <Section className="results-section">
                <div className="flex-container">
                    <EstimatedScore
                        stage={stage}
                        type={type}
                    />
                    <Scores
                        company={company}
                        industryMedian={industryMedian}
                        industryNPS={industryNPS}
                    />
                </div>
                <div className="flex-container">
                    <Comparisons
                        yourScore={yourScore}
                        industryScore={industryScore}
                        digitalNativeScore={digitalNativeScore}
                    />
                </div>
            </Section>
        );
    }
}

export default ResultsContent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/results/ResultsContent.tsx